import { getV1Languages } from "../api-client/api.system-feature/api";
import { getToken } from "./common";

export async function fetchLanguages() {

  const response = await getV1Languages({
    order: `id:1`,
    ...getToken(),
  });
  const data = response?.data?.languages || [];
  const languages = data?.filter(d => d?.is_active)?.map(d => {
    return {
      label: d?.name,
      code: d?.code,
      direction: d?.direction
    }
  });

  return languages
}